import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();

if (loading) {
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div className="w-12 h-12 border-4 border-green-500 border-dashed rounded-full animate-spin"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  );
}


  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if(user.role === 'admin' && user.role !== role){ return <Navigate to="/" />; } 
  if(user.role === 'user' && user.role !== role){ return <Navigate to="/" />; } 
  if(user.role === 'employee' && user.role !== role){ return <Navigate to="/" />; }

  if (role && user.role !== role) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
